import { OutcomeOption } from 'lib/form/tag-autocomplete/outcomes/tag-autocomplete-outcomes.constants';
import type { SearchOutcomesQuery } from '../graphql/outcomes/outcomes.graphql.generated';
import { TeachingAndLearningOutcome } from './teaching-learning-sequence.constants';
import type { Pluck } from 'lib/gql/pluck';

function getRemovedOutcomes(
  savedOutcomes: TeachingAndLearningOutcome[],
  updatedOutcomeList: OutcomeOption[]
) {
  const currentOutcomes = [...savedOutcomes];
  return currentOutcomes.filter(co =>
    updatedOutcomeList.find(d => d.value === co.id)
  );
}

function addUpdatedOutcomeList({
  savedOutcomes,
  updatedOutcomeList,
  fullOutcomeList,
}: {
  savedOutcomes: TeachingAndLearningOutcome[];
  updatedOutcomeList: OutcomeOption[];
  fullOutcomeList: TeachingAndLearningOutcome[];
}) {
  const currentOutcomes = [...savedOutcomes];
  updatedOutcomeList.forEach(no => {
    if (!currentOutcomes.find(so => so.id === no.value)) {
      const sourceOutcome = fullOutcomeList.find(
        outcome => outcome.id === no.value
      );
      if (sourceOutcome) {
        currentOutcomes.push(sourceOutcome);
      }
    }
  });
  return currentOutcomes;
}

export function addAndRemoveOptions({
  updatedOutcomeList,
  savedOutcomes,
  fullOutcomeList,
}: {
  updatedOutcomeList: OutcomeOption[];
  savedOutcomes: TeachingAndLearningOutcome[];
  fullOutcomeList: Pluck<SearchOutcomesQuery, 'searchOutcomes'>[];
}): TeachingAndLearningOutcome[] {
  if (updatedOutcomeList.length < savedOutcomes.length) {
    return getRemovedOutcomes(savedOutcomes, updatedOutcomeList);
  } else {
    return addUpdatedOutcomeList({
      savedOutcomes,
      updatedOutcomeList,
      fullOutcomeList,
    });
  }
}
